/*
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import blue from "@mui/material/colors/blue";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";

import ReactMarkdown from "react-markdown";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      marginTop: theme.spacing(3),

      "&:first-child": {
        marginTop: 0
      }
    },
    "& h1": {
      ...theme.typography.h2,
      textTransform: "uppercase"
    },
    "& p": {
      ...theme.typography.body1
    },
    "& a": {
      color: blue["200"],
      textDecoration: "underline"
    },
    "& ol, ul": {
      "& li": {
        ...theme.typography.body1,
        paddingLeft: theme.spacing(3),
        marginBottom: theme.spacing(2),
        position: "relative",
        "&:last-child": {
          marginBottom: 0
        },
        "& > ol, > ul": {
          marginTop: theme.spacing(2)
        }
      }
    },
    "& strong, b": {
      ...theme.typography.body1,
      fontWeight: 500,
      color: theme.palette.primary.main,
      textTransform: "uppercase"
    }
  }
}));

interface MarkdownProps {
  source: string;
}

export const Markdown = (props: MarkdownProps) => {
  const classes = useStyles();
  return (
    <div className={`${classes.root} marapp-qa-markdown`}>
      <ReactMarkdown {...props} />
    </div>
  );
};
